var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactNativeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 140,
    viewBox: "0 0 100 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "react-native-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 90,
    height: 134,
    rx: 16,
    stroke: "url(#paint0_linear_react_native)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 12,
    width: 24,
    height: 5,
    rx: 2.5,
    fill: "url(#paint1_linear_react_native)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(15 43.3) scale(0.5072)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6581 100.37C62.4388 96.8936 59.0747 92.8533 55.582 88.1718C49.3489 87.7861 42.3346 86.9637 35.4118 85.5071C31.093 102.766 34.7103 110.771 38.0899 112.819C44.5539 117.083 55.6269 109.757 65.6581 100.37ZM70.2411 105.041C58.81 115.611 45.428 123.958 36.0231 118.564C31.1053 116.003 25.0707 105.927 30.2583 84.2946C17.2033 80.878 5.28116 74.9589 0.606571 65.1536C-1.89213 58.4782 2.42236 46.1841 30.8242 38.65C27.5846 25.8602 27.1282 12.8212 33.6394 4.07339C38.2678 -1.14805 50.7424 -3.46075 70.1917 15.28C79.8042 6.31081 90.96 -0.399326 101.815 0.737615C108.848 2.07401 117.271 11.75 109.931 38.4427C124.543 42.6222 137.87 49.4263 137.99 59.7172C138.286 65.2375 132.363 75.7108 109.791 82.4682C113.49 97.5374 114.268 113.251 104.738 118.568C99.893 121.535 87.4565 121.539 70.2411 105.041ZM104.425 36.9993C109.848 18.197 105.933 9.45886 101.888 7.19323C93.4046 4.97105 83.4416 11.0644 74.4314 19.5879C78.1283 23.5349 82.0515 28.2132 86.1958 33.7301C91.5692 34.3867 97.9778 35.4525 104.425 36.9993ZM66.2381 19.1772C52.7294 5.8271 43.3218 4.85221 39.3721 7.11368C33.0732 13.3063 33.5981 25.0995 36.762 37.2246C41.7508 36.1432 47.3662 35.1971 53.6759 34.4268C57.2 29.4704 61.4744 24.1237 66.2381 19.1772ZM61.8524 33.5654C64.4767 30.219 67.3725 26.8059 70.4327 23.5853C72.9503 26.3859 75.5904 29.5975 78.3458 33.2697L67.6904 33.1011C65.6891 33.2409 63.7436 33.3959 61.8524 33.5654ZM49.2935 40.9752C45.3138 41.4633 41.6751 42.0423 38.3522 42.6933C39.5417 46.4218 40.9219 50.1067 42.3706 53.5941L47.2283 44.4033C47.8488 43.3271 48.539 42.1791 49.2935 40.9752ZM45.099 59.7823C45.1505 59.6746 45.2021 59.5668 45.254 59.4587L52.6707 46.5983C53.8772 44.6603 55.3106 42.4903 56.9289 40.1903C61.2268 39.8282 65.8641 39.5635 70.8644 39.4134L81.8719 39.6743C82.2498 39.7155 82.6359 39.7592 83.0299 39.8053C85.451 43.3335 87.9507 47.2065 90.5245 51.4538L95.1388 60.1231C93.17 64.103 90.9116 68.3445 88.3311 72.8604L82.4482 81.9417C82.3692 82.0429 82.2894 82.1448 82.2089 82.2473C81.9243 82.2767 81.6382 82.3057 81.3505 82.3343L66.2345 82.7299C63.8023 82.7146 61.0188 82.6216 58.0115 82.4315C57.7456 82.0613 57.4788 81.6871 57.2109 81.3089L49.569 68.5844C48.1777 66.0803 46.6421 63.0888 45.099 59.7823ZM38.7912 60.493C36.4503 55.4912 34.1655 49.8544 32.3476 44.0285C12.0277 49.1333 6.13349 57.1317 6.23635 61.7767C8.70342 70.137 19.4717 75.3768 31.8317 78.526C33.4671 73.1476 35.7384 67.1525 38.7912 60.493ZM37.057 79.7202C38.2934 75.81 39.8929 71.5038 41.9239 66.7738C42.9598 68.7235 43.97 70.5053 44.9176 72.0791L51.3155 81.8728C46.7087 81.3954 41.8359 80.6963 37.057 79.7202ZM86.6732 87.0818C92.9447 86.316 98.4971 85.3243 103.404 84.168C106.734 97.47 107.734 110.693 100.699 114.07C97.0921 115.974 87.7557 114.917 73.9791 101.443C78.9313 96.4918 83.3468 91.3469 86.6732 87.0818ZM77.6725 87.7581C75.1988 90.6363 72.3959 93.71 69.4273 96.704C67.2143 94.2626 64.9038 91.5173 62.5004 88.4359C64.1491 88.458 65.6964 88.4477 67.1185 88.4102L77.6725 87.7581ZM90.5753 81.2103L95.5047 73.4637C96.4927 71.5563 97.4305 69.695 98.3201 67.8789C99.5986 71.343 100.886 75.1712 102.03 79.1033C98.5891 79.8846 94.7817 80.5949 90.5753 81.2103ZM102.133 59.7187C104.217 64.5929 106.543 70.8326 108.449 77.4488C126.502 72.1824 131.824 64.8799 131.877 60.939C132.267 53.5939 120.924 48.2053 108.044 44.6251C106.514 49.211 104.566 54.2311 102.133 59.7187ZM98.5386 52.8745C100.064 49.4243 101.349 46.2004 102.421 43.192C98.6908 42.3204 94.9545 41.5936 91.4473 41.008C92.4975 42.52 93.5607 44.0841 94.6366 45.7017L98.5386 52.8745ZM70.3002 48.5532C74.6939 48.5532 82.3098 51.1286 82.3098 59.9992C82.3098 68.9534 75.5727 72.5898 71.1789 72.5898C66.7852 72.5898 57.9977 70.1888 57.9976 60.5715C57.9976 50.8424 65.9064 48.5532 70.3002 48.5532Z",
    fill: "url(#paint1_linear_react_native)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_react_native",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297814,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66328,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_react_native",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297814,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66328,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactNativeLogo);
export default __webpack_public_path__ + "static/media/react-native-logo.4f5f0239650081e8fbbc7ab23cf4ac7f.svg";
export { ForwardRef as ReactComponent };